import { render, staticRenderFns } from "./EvGroupLocalization.vue?vue&type=template&id=424a525c&scoped=true&"
import script from "./EvGroupLocalization.vue?vue&type=script&lang=js&"
export * from "./EvGroupLocalization.vue?vue&type=script&lang=js&"
import style0 from "./EvGroupLocalization.vue?vue&type=style&index=0&id=424a525c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a525c",
  null
  
)

export default component.exports